import React from 'react'
import classnames from 'classnames'

const BoxSVG = ({ className }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      className={classnames('dealmed-icon', className)}
      aria-hidden={true}
      focusable={false}
    >
      <path d="M31.454 9.238l-3.669-7.268c-0.564-1.2-1.764-1.905-3.034-1.905h-17.5c-1.27 0-2.47 0.706-3.034 1.905l-3.669 7.268c-0.212 0.494-0.353 0.988-0.353 1.552v16.371c0 2.47 2.046 4.516 4.516 4.516h22.581c2.47 0 4.516-2.046 4.516-4.516v-16.371c0-0.565-0.141-1.058-0.353-1.552zM17.129 2.323h7.621c0.423 0 0.847 0.212 1.058 0.635l3.034 6.139h-11.714v-6.774zM6.192 2.958c0.212-0.423 0.635-0.635 1.058-0.635h7.621v6.774h-11.714l3.034-6.139zM29.548 27.161c0 1.27-0.988 2.258-2.258 2.258h-22.581c-1.27 0-2.258-0.988-2.258-2.258v-15.806h27.097v15.806z"></path>
    </svg>
  )
}

export default BoxSVG
